import React from "react";

export default function renderIcon({
  width = 24,
  height = 24,
  color = "#495057",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 11H16.5V9H18.5C18.9167 9 19.271 8.85433 19.563 8.563C19.855 8.27167 20.0007 7.91733 20 7.5V6.5C20 6.08333 19.8543 5.72933 19.563 5.438C19.2717 5.14667 18.9173 5.00067 18.5 5H15V11ZM16.5 7.5V6.5H18.5V7.5H16.5ZM13 14C12.45 14 11.9793 13.8043 11.588 13.413C11.1967 13.0217 11.0007 12.5507 11 12V4C11 3.45 11.196 2.97933 11.588 2.588C11.98 2.19667 12.4507 2.00067 13 2H21C21.55 2 22.021 2.196 22.413 2.588C22.805 2.98 23.0007 3.45067 23 4V12C23 12.55 22.8043 13.021 22.413 13.413C22.0217 13.805 21.5507 14.0007 21 14H18V21H16V14H13ZM8 21C7.71667 21 7.47933 20.904 7.288 20.712C7.09667 20.52 7.00067 20.2827 7 20V19H2V10H7.2L6.15 7H2V5H6.5C6.81667 5 7.10433 5.09167 7.363 5.275C7.62167 5.45833 7.80067 5.7 7.9 6L10 12V20C10 20.2833 9.904 20.521 9.712 20.713C9.52 20.905 9.28267 21.0007 9 21H8ZM5.5 16C5.91667 16 6.271 15.8543 6.563 15.563C6.855 15.2717 7.00067 14.9173 7 14.5C6.99933 14.0827 6.85367 13.7287 6.563 13.438C6.27233 13.1473 5.918 13.0013 5.5 13C5.082 12.9987 4.728 13.1447 4.438 13.438C4.148 13.7313 4.002 14.0853 4 14.5C3.998 14.9147 4.144 15.269 4.438 15.563C4.732 15.857 5.086 16.0027 5.5 16Z"
        fill={color}
      />
    </svg>
  );
}
